import { type ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getFeatureFlags, type RootState } from '@a1/shared';
import FeatureFlagsContext from './FeatureFlagsContext';

interface FeatureFlagsProviderProps {
  children: ReactNode;
}

/**
 * Single Redux subscriber for feature flags. Mount once near the top of the authenticated
 * layout so all descendants can read flags via use(FeatureFlagsContext) without each
 * needing their own selector.
 *
 * REMINDER: Split Contexts and Providers into separate files to allow for hot-reloading of Providers without affecting Context consumers!
 */
const FeatureFlagsProvider = ({ children }: FeatureFlagsProviderProps) => {
  const appConfig = useSelector((state: RootState) => state.appConfig?.data);
  const flags = useMemo(() => getFeatureFlags(appConfig), [appConfig]);

  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>;
};

export default FeatureFlagsProvider;
